"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TabGroup = _interopRequireDefault(require("./TabGroup"));

var _Tab = _interopRequireDefault(require("./Tab"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var generateTabMap = function generateTabMap(tabs) {
  return tabs.reduce(function (tabAcc, tab) {
    return _objectSpread({}, tabAcc, _defineProperty({}, tab.id, tab));
  }, {});
};

var validateIcons = function validateIcons(tabs) {
  var tabsWithIcons = tabs.filter(function (tab) {
    return Boolean(tab.icon);
  });
  var isValid = !tabsWithIcons.length || tabsWithIcons.length === tabs.length;

  if (!isValid) {
    console.warn('TabMenu: All tabs must have icons for them to render. Ignoring icons for all tabs...');
  }

  return isValid;
};

var validateDescriptions = function validateDescriptions(tabs) {
  var tabsWithDescriptions = tabs.filter(function (tab) {
    return Boolean(tab.description);
  });
  var isValid = !tabsWithDescriptions.length || tabsWithDescriptions.length === tabs.length;

  if (!isValid) {
    console.warn('TabMenu: All tabs must have descriptions for them to render. Ignoring descriptions for all tabs...');
  }

  return isValid;
};

var TabMenu = function TabMenu(_ref) {
  var activeTabId = _ref.activeTabId,
      tabs = _ref.tabs,
      tabGroups = _ref.tabGroups,
      onTabClick = _ref.onTabClick;

  var _useState = (0, _react.useState)(generateTabMap(tabs)),
      _useState2 = _slicedToArray(_useState, 2),
      tabMap = _useState2[0],
      setTabMap = _useState2[1];

  var _useState3 = (0, _react.useState)(validateIcons(tabs)),
      _useState4 = _slicedToArray(_useState3, 2),
      showIcons = _useState4[0],
      setShowIcons = _useState4[1];

  var _useState5 = (0, _react.useState)(validateDescriptions(tabs)),
      _useState6 = _slicedToArray(_useState5, 2),
      showDescriptions = _useState6[0],
      setShowDescriptions = _useState6[1];

  (0, _react.useEffect)(function () {
    // Create a lookup mapping of tabs by id to optimize
    setTabMap(generateTabMap(tabs));
    setShowIcons(validateIcons(tabs));
    setShowDescriptions(validateDescriptions(tabs));
  }, [tabs]);

  if (!tabs || !tabs.length) {
    return null;
  }

  var activeTab = tabs[0];

  if (activeTabId) {
    activeTab = tabMap[activeTabId] || activeTab;
  }

  return _react["default"].createElement("div", {
    className: "tab-menu"
  }, _react["default"].createElement("div", {
    className: "tabs"
  }, tabGroups.length > 1 ? tabGroups.map(function (_ref2) {
    var label = _ref2.label,
        _ref2$tabIds = _ref2.tabIds,
        tabIds = _ref2$tabIds === void 0 ? [] : _ref2$tabIds;
    return _react["default"].createElement(_TabGroup["default"], {
      key: "".concat(label, "-").concat(tabIds.join('-')),
      label: label
    }, tabIds.map(function (tabId) {
      var _tabMap$tabId = tabMap[tabId],
          id = _tabMap$tabId.id,
          title = _tabMap$tabId.title,
          description = _tabMap$tabId.description,
          icon = _tabMap$tabId.icon;
      return _react["default"].createElement(_Tab["default"], _extends({
        key: id,
        id: id,
        title: title,
        onTabClick: onTabClick,
        isActive: activeTab.id === id
      }, showIcons ? {
        icon: icon
      } : {}, showDescriptions ? {
        description: description
      } : {}));
    }));
  }) : tabs.map(function (_ref3) {
    var id = _ref3.id,
        title = _ref3.title,
        description = _ref3.description,
        icon = _ref3.icon;
    return _react["default"].createElement(_Tab["default"], _extends({
      key: id,
      id: id,
      title: title,
      onTabClick: onTabClick,
      isActive: activeTab.id === id
    }, showIcons ? {
      icon: icon
    } : {}, showDescriptions ? {
      description: description
    } : {}));
  })), _react["default"].createElement("div", {
    className: "active-tab-body"
  }, activeTab && activeTab.body));
};

var tabShape = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  icon: _propTypes["default"].func,
  body: _propTypes["default"].node
});

var tabGroupShape = _propTypes["default"].shape({
  label: _propTypes["default"].string.isRequired,
  tabIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
});

TabMenu.propTypes = {
  activeTabId: _propTypes["default"].string,
  tabs: _propTypes["default"].arrayOf(tabShape).isRequired,
  tabGroups: _propTypes["default"].arrayOf(tabGroupShape),
  onTabClick: _propTypes["default"].func
};
TabMenu.defaultProps = {
  onTabClick: function onTabClick() {},
  tabGroups: []
};
var _default = TabMenu;
exports["default"] = _default;